var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GeneralScaffold',[_c('PagedDataTable',{attrs:{"i18nGroup":"product-category","form-route":"productCategoryForm","headers":_vm.headers,"repository":_vm.productCategoryRepository}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }